var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2StrongWind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.1 42.43A7.58 7.58 0 0153.55 50H25v-4h28.53a3.57 3.57 0 003.57-3.57A2.45 2.45 0 0054.65 40a1.57 1.57 0 00-1.57 1.56 2 2 0 11-4 0A5.58 5.58 0 0154.65 36a6.46 6.46 0 016.45 6.43zM53 27.55l-34 7.94V66h-4V7.46L53 18v9.55zM24 14.1l-5-1.39V31.4l5-1.17V14.1zm12 3.32l-6-1.66v13.07l6-1.4V17.42zM49 21l-7-1.94V26l7-1.64V21zm-5.2 32H25v4h18.45A3.57 3.57 0 0147 60.55 2.45 2.45 0 0144.56 63 1.56 1.56 0 0143 61.44a2 2 0 00-4 0A5.57 5.57 0 0044.56 67 6.45 6.45 0 0051 60.55 7.57 7.57 0 0043.8 53z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Strong_wind.fa3e490b.svg";
export { SvgB2StrongWind as ReactComponent };